// test1683
(1683 && 0);
